// extracted by mini-css-extract-plugin
module.exports = {"signup_module":"signupModal_signup_module__GRjAL","mySelect":"signupModal_mySelect__3rg5v"};